import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {CountryCodeEnum} from '../../../enums/country-code.enum';
import {DatePipe} from '@angular/common';
import {EditModalSectionBaseComponent} from '../edit-modal-section-base.component';
import {EditModalService} from '../../../services/edit-modal.service';
import {IndustrySectorEnum} from '../../../enums/industry-sector.enum';
import {ProjectEmployeeCountRangeEnum} from '../../../enums/project-employee-count-range.enum';
import {ProjectModel} from '../../../models/project.model';
import {AccountModel} from '../../../models/account.model';
import {ContactModel, KamModel} from '../../../models/brother-contacts.model';
import {MyProjectStatusBarTranslateEnum} from '../../../enums/my-project-status-bar-translate.enum';

@Component({
    selector: 'app-projects-simple-section-viewer',
    templateUrl: './simple-section-viewer.component.html',
    styleUrls: ['./simple-section-viewer.component.scss']
})
export class ProjectsSimpleSectionViewerComponent extends EditModalSectionBaseComponent implements OnChanges, OnInit {

    @Input() public sectionType:
        'END_USER' |
        'PROJECT' |
        'EMPLOYEE' |
        'ACCOUNT' |
        'WARRANTY_NOTES' |
        'NONE' = 'NONE';

    // modelChangedTrigger changes  will trigger ngOnChanges/recalculate values via input value,
    // currently is used to reinit EMPLOYEE section only
    @Input() public modelChangedTrigger: any = null;

    public sectionModel: object;

    public sectionsContent: { title: string, fields: any, fieldsForInternalUser: any };

    public sectionsContents = {
        'END_USER': {
            title: 'Endanwenderdaten',
            fields: [
                {label: 'Firma:', subModelName: 'company', fieldName: 'name'},
                {label: 'Branche:', fieldName: 'industrySector', formatType: 'COUNT'},
                {label: 'Abteilung:', fieldName: 'department'},
                {label: 'Mitarbeiteranzahl:', fieldName: 'employeeCountRange', formatType: 'COUNT'},
                {label: 'Straße und Nummer:', subModelName: 'company', fieldName: 'street'},
                {label: 'PLZ:', subModelName: 'company', fieldName: 'zip'},
                {label: 'Ort:', subModelName: 'company', fieldName: 'city'},
                {label: 'Land:', subModelName: 'company', fieldName: 'country', formatType: 'COUNT'},
            ] as { label: string, subModelName?: string, fieldName: string, formatType?: string }[],

        },
        'PROJECT': {
            title: 'Projektdaten',
            fields: [
                {label: 'Projektname:', fieldName: 'projectName'},
                {label: 'Angebotsabgabe:', fieldName: 'quoteClosingDate', formatType: 'DATE'},
                {label: 'Bemerkung:', fieldName: 'comment'},
                {label: 'Gültig bis:', fieldName: 'validityOfQuotation', formatType: 'DATE'},
            ] as { label: string, subModelName?: string, fieldName: string, formatType?: string }[],
            fieldsForInternalUser: [
                {label: 'Projektname:', fieldName: 'projectName'},
                {label: 'Kontraktnummer:', fieldName: 'referenceNo'},
                {label: 'Angebotsabgabe:', fieldName: 'quoteClosingDate', formatType: 'DATE'},
                {label: 'Angebotsgültig.:', fieldName: 'quoteValidUntil', formatType: 'DATE'},
                {label: 'Bemerkung:', fieldName: 'comment'},
            ] as { label: string, subModelName?: string, fieldName: string, formatType?: string }[]
        },
        'EMPLOYEE': {
            title: 'Mitarbeiter',
            fields: [
                {label: 'KAM:', fieldName: 'kam'},
                {label: 'VL:', fieldName: 'vl'},
                {label: 'Innendienst:', fieldName: 'innendienst'},
                {label: 'Brother-GL:', fieldName: 'brotherGlContact'},
                {label: 'Status:', fieldName: 'status', formatType: 'COUNT'},
            ] as { label: string, subModelName?: string, fieldName: string, formatType?: string }[]
        },
        'ACCOUNT': {
            title: 'Händler',
            fields: [
                {label: 'Kundennummer:', fieldName: 'accountNo'},
                {label: 'Firma:', fieldName: 'name'},
                {label: 'Kontakt:', fieldName: 'countContact', formatType: 'COUNT'},
                {label: 'Tel:', fieldName: 'phone'},
                {label: 'E-Mail:', subModelName: 'projectCreator', fieldName: 'email'},
            ] as { label: string, subModelName?: string, fieldName: string, formatType?: string }[]
        },
        'WARRANTY_NOTES': {
            title: 'Kommentare',
            fields: [
                {label: 'Geräte, Zubehör und Full Service Pack Kommentar:', fieldName: 'commentHardware'},
                {label: 'Verbrauchsmaterial Kommentar:', fieldName: 'commentSupplies'},
            ] as { label: string, subModelName?: string, fieldName: string, formatType?: string }[]
        },
    };


    constructor(public  editModalService: EditModalService) {
        super(editModalService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.reinit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.reinit();
    }

    private reinit() {


        if (this.sectionType && this.model) {
            switch (this.sectionType) {
                case 'END_USER':
                    this.sectionModel = this.model.project as ProjectModel;
                    break;
                case  'PROJECT':
                    this.sectionModel = this.model.project as ProjectModel;
                    break;
                case   'EMPLOYEE' :
                    // this.sectionModel = this.model.project as ProjectModel;
                    // to make it working, the reinit must be triggered via modelChangedTrigger input variable
                    // for example: editModalService.currentStepId === stepsEnum.STEP6
                    //     will trigger this reinit before the step6 will be displayed
                    const project = this.model.project;
                    this.sectionModel = {
                        kam: this.getBrotherContactName(
                            project.brotherContacts.kam.kamContacts,
                            project.brotherContacts.kam.selectedKamContact
                        ),
                        vl: this.getBrotherVLContactName(
                            project.brotherContacts.kam
                        ),
                        innendienst: this.getBrotherContactName(
                            project.brotherContacts.innendienst.innendienstContacts,
                            project.brotherContacts.innendienst.selectedInnendienstContact),
                        brotherGlContact: project.brotherContacts.brotherGlContact,
                        status: project.status // ProjectStatusEnum[this.model.project.status]
                    };
                    break;
                case  'ACCOUNT':
                    this.sectionModel = this.model.project.account as AccountModel;
                    break;
                case  'WARRANTY_NOTES':
                    this.sectionModel = this.model.project as ProjectModel;
                    break;
                case  'NONE':
                    break;
                default:
                    console.error('unexpected section type:', this.sectionType);
            }
        }
        this.reinitSectionContent();
    }


    private getBrotherContactName(contacts: ContactModel[], contactId: number): string {
        const contact = contacts.find(
            con => con.id === contactId
        );
        return contact ? contact.name : null;
    }

    private getBrotherVLContactName(kamContacts: KamModel): string {
        const contact = kamContacts.kamContacts.find(
            con => con.id === kamContacts.selectedKamContact
        );
        return contact && contact.verkaufsLeiter ? contact.verkaufsLeiter : null;
    }

    public getFieldText(field: { label: string, subModelName?: string, fieldName: string, formatType?: string }): string {
        if (!this.sectionType || !this.sectionModel) {
            return '';
        }


        const currentModel = field.subModelName ? this.sectionModel[field.subModelName] : this.sectionModel;

        let textToDisplay =  currentModel[field.fieldName];
        switch (field.formatType) {
            case  'DATE':
                const date = this.sectionModel[field.fieldName];
                textToDisplay = date ? new DatePipe('de_DE').transform(date, 'dd.MM.yyyy') : null;
                break;

            case  'VALUE':
                textToDisplay = field.fieldName;
                break;

            case 'COUNT':

                if (this.sectionType === 'ACCOUNT' && field.fieldName === 'countContact') {
                    textToDisplay = this.sectionModel['projectCreator']['salutation'] + ' '
                        + (this.sectionModel['projectCreator']['firstName'] ? this.sectionModel['projectCreator']['firstName'] + ' ' : '')
                        + this.sectionModel['projectCreator']['lastName'];
                }

                if (this.sectionType === 'END_USER') {

                    switch (field.fieldName) {
                        case 'industrySector':
                            textToDisplay = IndustrySectorEnum[this.sectionModel[field.fieldName]];
                            break;
                        case 'employeeCountRange':
                            textToDisplay = ProjectEmployeeCountRangeEnum[this.sectionModel[field.fieldName]];
                            break;
                        case 'country':
                            textToDisplay = CountryCodeEnum[this.sectionModel[field.subModelName][field.fieldName]];
                            break;
                    }
                }

                if (this.sectionType === 'EMPLOYEE') {

                    switch (field.fieldName) {
                        case 'status':
                            textToDisplay = MyProjectStatusBarTranslateEnum[this.sectionModel[field.fieldName]];
                            break;
                    }
                }
        }


        // tslint:disable-next-line:triple-equals
        return textToDisplay != undefined && textToDisplay !== '' ? textToDisplay.toString() : '–';
    }

    private reinitSectionContent() {
        this.sectionsContent = this.sectionsContents[this.sectionType];
        if (this.editModalService.isInternalUser() && this.sectionsContent.fieldsForInternalUser) {
            this.sectionsContent.fields = this.sectionsContent.fieldsForInternalUser;
        }
    }
}

